<template>
	<div class="container-fluid container-logon">
		<div class="d-flex justify-content-center h-100">
			<div class="user_card">
				<div class="d-flex justify-content-center">
					<div class="brand_logo_container">
						<img class="brand_logo" src="img/logo-ordergo.svg" />
					</div>
				</div>
				<div class="d-flex justify-content-center caption" :class="{isError : !isAlive}">
					<translate item="Login.Title" />
				</div>	
				<div class="d-flex justify-content-center form_container">
					<form @submit="login">

						<label for="uid" class="form-label"><translate item="Login.Username" /></label>
						<input type="text" name="uid" required class="form-control input_user" v-model="uid" placeholder="">

						<label for="uid" class="form-label"><translate item="Login.Password" /></label>
						<input type="password" name="pwd" required class="form-control input_pass" v-model="pwd" placeholder="">
						
						<div class="input-group validionmessage isError">
							<div class="message" v-if="message.length">{{message}}</div>
						</div>
						<div class="d-flex justify-content-center mt-3 login_container">
							<button type="submit" name="button" class="btn btn-dark"><translate item="Login.Submit" /></button>
						</div>
					</form>

				</div>

				<!--<div class="mt-4">
		<div class="d-flex justify-content-center links">
			Don't have an account? <a href="#" class="ml-2">Sign Up</a>
		</div>
		<div class="d-flex justify-content-center links">
			<a href="#">Forgot your password?</a>
		</div>
	</div>-->
			</div>
		</div>
	</div>
</template>

<script>

	import 'bootstrap/scss/bootstrap.scss';
	import 'font-awesome/scss/font-awesome.scss';

	import axios from 'axios';
	import config from '../repositories/ConfigRepository';
    import translate from '../components/translate'

	export default {

		name: 'login',

        components: { translate },

		data: function () {
			return {
				uid: '',
				pwd: '',
				success: false,
				message: '',
				endpoint: config.endPointUrl,
				isAlive : false
			}
		},

		methods: {

			login: function (e) {
				var _this = this;
				e.preventDefault();
				if (!this.uid.length) {
					_this.message = "The username is required";
					return false;
				}
				if (!this.pwd.length) {
					_this.message = "The password is required";
					return false;
				}


				var bodyFormData = new FormData();
				bodyFormData.set('uid', this.uid);
				bodyFormData.set('pwd', this.pwd);

				// axios, for a full list of options see: https://github.com/axios/axios
				axios({
					method: 'post',
					url: config.endPointUrl + 'account/terminallogin',
					data: bodyFormData,
					withCredentials: true
				}).then(function (response) {
					window.console.log(response);
					_this.success = response.data.success;
					_this.message = response.data.message;

					if (_this.success) {
						window.location = "/";
					}

				}).catch(function (err) {
					window.console.log('#login.vuw: Error loging in');
					window.console.log(err);
				});
			},

			getIsAlive: function () {
				var _this = this;
				_this.checking = true;

				axios({
					method: 'GET',
					url: config.endPointUrl + 'api/terminal/isAlive',
					withCredentials: true
				}).then(function (response) {
					_this.checking = false;
					if (response.data) {
						_this.isAlive = true;
					} else {
						_this.isAlive = false;		
                        _this.message = "The url '" + config.endPointUrl + "' could not be reached!";
					}
				}).catch(function () {
					_this.checking = false;
					_this.isAlive = false;
                    _this.message = "The url '" + config.endPointUrl + "' could not be reached!";
				});
			}
		},

		mounted: function () {
			this.getIsAlive();
		}
	};
</script>

